import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getSupabaseClient } from '../supabaseClient';

const PropertyManagementRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isPropertyManagement, setIsPropertyManagement] = useState(false);
  const supabase = getSupabaseClient();

  useEffect(() => {
    checkBusinessType();
  }, []);

  const checkBusinessType = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setLoading(false);
        return;
      }

      const { data: account, error } = await supabase
        .from('accounts')
        .select('business_type')
        .eq('id', user.id)
        .single();

      if (!error && account?.business_type === 'property_management') {
        setIsPropertyManagement(true);
      }
    } catch (error) {
      console.error('Error checking business type:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isPropertyManagement) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default PropertyManagementRoute; 